import { useCurrentUser } from '@/models/user'

/** Cai staff: the server records no accuracy consent from them. */
export function useStaffSession(): boolean {
  const { user } = useCurrentUser({ enabled: false })
  return !!user?.isCaiAdmin
}
